import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-5'}`} data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="flex justify-between items-center" data-id="element-82">
          {/* Logo / Practice Name */}
          <div className="flex flex-col" data-id="element-83">
            <span className="text-xl md:text-2xl font-bold text-slate-900 tracking-tight" data-id="element-84">
              Lehigh Valley Weight Loss
            </span>
            <span className="text-xs md:text-sm text-slate-500 font-medium" data-id="element-85">
              Maneesh Ailawadi, MD, FSSO
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-86">
            {/* Language Toggle */}
            <div className="bg-slate-100 p-1 rounded-full flex items-center" data-id="element-87">
              <button onClick={() => setLanguage('en')} className={`px-3 py-1 text-sm font-medium rounded-full transition-colors ${language === 'en' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-88">
                EN
              </button>
              <button onClick={() => setLanguage('es')} className={`px-3 py-1 text-sm font-medium rounded-full transition-colors ${language === 'es' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-89">
                ES
              </button>
            </div>

            {/* Phone Link */}
            <a href="tel:4849341070" className="flex items-center text-slate-600 hover:text-teal-600 font-medium transition-colors" data-id="element-90">
              <Phone className="w-4 h-4 mr-2" data-id="element-91" />
              484-934-1070
            </a>

            {/* CTA Button */}
            <button onClick={scrollToContact} className="bg-teal-600 hover:bg-teal-700 text-white px-5 py-2.5 rounded-lg font-semibold transition-colors shadow-sm hover:shadow text-sm" data-id="element-92">
              {t('Schedule a Consultation', 'Agendar consulta')}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-93">
            <a href="tel:4849341070" className="mr-4 text-slate-600 p-2" aria-label="Call office" data-id="element-94">
              <Phone className="w-5 h-5" data-id="element-95" />
            </a>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-900 p-2" aria-label="Toggle menu" data-id="element-96">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-97" /> : <Menu className="w-6 h-6" data-id="element-98" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-99">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-slate-100 overflow-hidden" data-id="element-100">
            <div className="px-4 py-6 space-y-6" data-id="element-101">
              {/* Mobile Language Toggle */}
              <div className="flex justify-center" data-id="element-102">
                <div className="bg-slate-100 p-1 rounded-full flex items-center inline-flex" data-id="element-103">
                  <button onClick={() => setLanguage('en')} className={`px-6 py-2 text-sm font-medium rounded-full transition-colors ${language === 'en' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500'}`} data-id="element-104">
                    English
                  </button>
                  <button onClick={() => setLanguage('es')} className={`px-6 py-2 text-sm font-medium rounded-full transition-colors ${language === 'es' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500'}`} data-id="element-105">
                    Español
                  </button>
                </div>
              </div>

              <div className="flex flex-col space-y-4" data-id="element-106">
                <a href="tel:4849341070" className="flex items-center justify-center w-full py-3 border border-slate-200 rounded-lg text-slate-700 font-medium" data-id="element-107">
                  <Phone className="w-4 h-4 mr-2" data-id="element-108" />
                  484-934-1070
                </a>
                <button onClick={scrollToContact} className="w-full bg-teal-600 text-white py-3 rounded-lg font-semibold shadow-sm" data-id="element-109">
                  {t('Schedule a Consultation', 'Agendar consulta')}
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}